/// <reference types="@angular/localize" />
import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import * as Sentry from '@sentry/angular';
import dayjs             from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import LocalizedFormat   from 'dayjs/plugin/localizedFormat';
import relativeTime      from 'dayjs/plugin/relativeTime';
import weekOfYear        from 'dayjs/plugin/weekOfYear';

import { AppModule }   from './app/app.module';

import { environment } from './environments/environment';

dayjs.extend(customParseFormat);
dayjs.extend(LocalizedFormat);
dayjs.extend(weekOfYear);
dayjs.extend(relativeTime);

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.name,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.consoleLoggingIntegration()
    ],
    tracesSampleRate: 0.2
  });
}

if (environment.production) {
  enableProdMode();
}
platformBrowser().bootstrapModule(AppModule);
